import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _class, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "87fd6HYLGBIEYhJbwLWw4WY", "FollowBall", undefined);

import { _decorator, Component, v3, Vec3, v2, RigidBody } from 'cc';
import { E_GameState } from './common/EnumBase';
import { App } from './common/manager/App';
var ccclass = _decorator.ccclass,
    property = _decorator.property;
export var FollowBall = (_dec = ccclass('FollowBall'), _dec(_class = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(FollowBall, _Component);

  function FollowBall() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "_preZ", -9999);

    _defineProperty(_assertThisInitialized(_this), "_interval", 0);

    _defineProperty(_assertThisInitialized(_this), "_yRange_zone", v2());

    _defineProperty(_assertThisInitialized(_this), "_yRange_cur", v2());

    return _this;
  }

  var _proto = FollowBall.prototype;

  _proto.start = function start() {
    // [3]
    var h_base = App.DataMgr.vBaseSize_game.height;
    this._yRange_cur = v2(-h_base / 2, h_base / 2);
    this._yRange_zone = v2(0, h_base / 2 * 0.75);
  };

  _proto.lateUpdate = function lateUpdate(dt) {
    if (App.GameCtrl.ball_game && App.GameCtrl.gameState == E_GameState.Gaming) {
      var x_offset = 0;
      var v_ball = v3();
      App.GameCtrl.ball_game.getComponent(RigidBody).getLinearVelocity(v_ball);
      x_offset = v_ball.x / 20 * 6;
      var x = App.GameCtrl.ball_game.worldPosition.x + x_offset;
      var y = 0;
      var z = App.DataMgr.zBaseIndex_game;
      var sizeAim = App.DataMgr.vBaseSize_game;

      if (!App.GameCtrl.isFristTouchLineAndBall) {
        var sizeBase = App.DataMgr.vBaseSize_game;
        var n_ball = App.GameCtrl.ball_game;
        var y_delay = 0;

        if (n_ball.worldPosition.y < this._yRange_zone.x) {
          y_delay = n_ball.worldPosition.y - this._yRange_zone.x;
        } else if (n_ball.worldPosition.y > this._yRange_zone.y) {
          y_delay = n_ball.worldPosition.y - this._yRange_zone.y;
        }

        if (y_delay + this._yRange_zone.x < 0) {
          y_delay = -this._yRange_zone.x;
        }

        this._yRange_zone.add(v2(y_delay, y_delay)); // this._yRange_cur.add(v2(y_delay, y_delay));


        z = y_delay * 2 / App.DataMgr.rate_z2h + this.node.worldPosition.z;
        sizeAim = App.DataMgr.getCamSizeByZ(z);
        y = (sizeAim.height - sizeBase.height) / 2;
      } // let z: number = App.DataMgr.getGameCamZidnex();


      var pos_out = v3(x, y, z);
      var pos_aim = v3();
      Vec3.lerp(pos_aim, this.node.worldPosition, pos_out, 0.1);
      pos_aim.y = y;
      pos_aim.z = z;
      this.node.setWorldPosition(pos_aim);
      App.GameCtrl.cam_bg.node.setPosition(pos_aim);
      App.DataMgr.vSize_game = sizeAim;
      App.GameCtrl.n_bg.setPosition(v3(pos_aim.x, 0, -20));
    }
  };

  return FollowBall;
}(Component), _temp)) || _class);
/**
 * [1] Class member could be defined like this.
 * [2] Use `property` decorator if your want the member to be serializable.
 * [3] Your initialization goes here.
 * [4] Your update function goes here.
 *
 * Learn more about scripting: https://docs.cocos.com/creator/3.0/manual/en/scripting/
 * Learn more about CCClass: https://docs.cocos.com/creator/3.0/manual/en/scripting/ccclass.html
 * Learn more about life-cycle callbacks: https://docs.cocos.com/creator/3.0/manual/en/scripting/life-cycle-callbacks.html
 */

_cclegacy._RF.pop();